import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XIcon, CameraIcon, ImageIcon, FileBoxIcon } from 'lucide-react';
export function UploadOptions() {
  const navigate = useNavigate();
  return <div className="w-full h-full bg-black/90 backdrop-blur-md flex flex-col relative" data-id="element-766">
      <div className="absolute top-6 left-4 z-10" data-id="element-767">
        <button onClick={() => navigate(-1)} className="w-10 h-10 bg-surface rounded-full flex items-center justify-center text-white hover:bg-surface2 transition-colors" data-id="element-768">
          <XIcon size={20} data-id="element-769" />
        </button>
      </div>

      <div className="flex-1 flex flex-col items-center justify-end pb-20 px-6" data-id="element-770">
        <motion.div initial={{
        y: 50,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} className="w-full flex justify-center gap-8 mb-12" data-id="element-771">
          {/* Gallery */}
          <div className="flex flex-col items-center gap-3" data-id="element-772">
            <button onClick={() => navigate('/upload/preview')} className="w-16 h-16 rounded-full bg-surface border border-border flex items-center justify-center text-white hover:bg-surface2 transition-colors" data-id="element-773">
              <ImageIcon size={28} data-id="element-774" />
            </button>
            <span className="text-white text-sm font-medium" data-id="element-775">Gallery</span>
          </div>

          {/* Record (Center, Larger) */}
          <div className="flex flex-col items-center gap-3 -mt-8" data-id="element-776">
            <button onClick={() => navigate('/upload/record')} className="w-24 h-24 rounded-full bg-primary flex items-center justify-center text-black shadow-[0_0_30px_rgba(255,212,0,0.4)] hover:scale-105 transition-transform" data-id="element-777">
              <CameraIcon size={40} strokeWidth={2.5} data-id="element-778" />
            </button>
            <span className="text-primary font-bold" data-id="element-779">Record</span>
          </div>

          {/* Drafts */}
          <div className="flex flex-col items-center gap-3" data-id="element-780">
            <button className="w-16 h-16 rounded-full bg-surface border border-border flex items-center justify-center text-white hover:bg-surface2 transition-colors relative" data-id="element-781">
              <FileBoxIcon size={28} data-id="element-782" />
              <div className="absolute -top-1 -right-1 w-5 h-5 bg-neonOrange rounded-full flex items-center justify-center text-[10px] font-bold text-white border-2 border-black" data-id="element-783">
                3
              </div>
            </button>
            <span className="text-white text-sm font-medium" data-id="element-784">Drafts</span>
          </div>
        </motion.div>
      </div>
    </div>;
}